import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { safeJsonParse } from '../../../utils/safeJsonParse';
import styles from './index.module.scss';
import FooterContent from '../../render_components/other_components/footer';

const FOOTER_TEMPLATE_NAMES = ['footer'];

const Footer = () => {
  const others = useSelector((state) => state.others_data.others);
  const [othersToRender, setOthersToRender] = useState([]);

  // Явный рендер other-компонентов: перебор others по template_name
  useEffect(() => {
    if (!others || !Array.isArray(others)) {
      setOthersToRender([]);
      return;
    }
    const allowed = new Set(FOOTER_TEMPLATE_NAMES);
    const list = [];
    others.forEach((el) => {
      const template = safeJsonParse(el.template, {});
      const name = template?.template_name;
      if (name && allowed.has(name)) {
        list.push({
          template_name: name,
          contentData: safeJsonParse(el.content, []),
          path_to_folder:
            el.path && el.blank_name ? 'https://' + el.path + el.blank_name + '/' : null,
        });
      }
    });
    setOthersToRender(list);
  }, [others]);

  const renderableFooters = othersToRender.filter(
    (item) => Array.isArray(item.contentData) && item.contentData.length > 0,
  );

  if (renderableFooters.length === 0) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.futerContainer}>
        {renderableFooters.map((item, idx) => {
          switch (item.template_name) {
            case 'footer':
              return (
                <FooterContent
                  key={idx}
                  contentData={item.contentData}
                  path_to_folder={item.path_to_folder}
                />
              );
            default:
              return null;
          }
        })}
      </div>
    </footer>
  );
};

export default Footer;
